import React, { useState, useMemo } from 'react'
import PropTypes from 'prop-types'
import { Flex } from 'reflexbox/styled-components'
import styled from 'styled-components'

import SubSection from 'components/page/Section/SubSection'
import BundleSummary from 'components/summaryCards/BundleSummary'

import { PLAN_CUSTOM } from '@anvilco-pkg/sanity'

import theme from 'theme'

import PlansSelector from './PlansSelector'

const FeaturesGrid = styled(Flex).withConfig({
  shouldForwardProp: (prop) => ['hasCoverImage'].indexOf(prop) === -1,
})`
  flex-wrap: wrap;
  gap: 22px;
  justify-content: ${({ hasCoverImage }) =>
    hasCoverImage ? 'flex-start' : 'center'};
`

const StyledSubSection = styled(SubSection)`
  padding-top: 0;
`

const BundleHeroFeaturesSubSection = ({
  features = [],
  hasCoverImage = false,
}) => {
  const [activePlan, setActivePlan] = useState(PLAN_CUSTOM)

  const selectedPlans = useMemo(
    () =>
      features.filter((feature) => feature.pricingPlan.includes(activePlan)),
    [features, activePlan]
  )

  if (features.length < 1) {
    throw new Error('No features found in this bundle')
  }

  return (
    <StyledSubSection background={theme.colors.gray}>
      <PlansSelector
        activePlan={activePlan}
        onChangePlan={setActivePlan}
        alignLeft={hasCoverImage}
      />
      <FeaturesGrid hasCoverImage={hasCoverImage}>
        {selectedPlans.map((feature, index) => (
          <BundleSummary feature={feature} key={feature.id} />
        ))}
      </FeaturesGrid>
    </StyledSubSection>
  )
}

BundleHeroFeaturesSubSection.propTypes = {
  features: PropTypes.arrayOf(PropTypes.object),
  hasCoverImage: PropTypes.bool,
}

export default BundleHeroFeaturesSubSection
